if (ctx === '/') {
  window.CKEDITOR_BASEPATH = '/ckeditor4/';
} else {
  window.CKEDITOR_BASEPATH = ctx+'/js/ckeditor4/';
}
